import { CheckboxField } from '@monorepo/shared/componentsV2/fields/CheckboxField';
import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import { FormTemplateFieldTypes } from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import { ModalFieldWrapper } from '../styled';

type EditDynamicDefaultFieldProps = {
  prefix?: string;
};

const supportedDynamicDefaultFieldTypes = new Set([
  FormTemplateFieldTypes.DATE,
  FormTemplateFieldTypes.TIME,
  FormTemplateFieldTypes.WEATHER,
  FormTemplateFieldTypes.USER,
]);

function getDynamicDefaultFieldLabel(fieldType: FormTemplateFieldTypes) {
  switch (fieldType) {
    case FormTemplateFieldTypes.DATE:
      return 'Default to current date';
    case FormTemplateFieldTypes.TIME:
      return 'Default to current time';
    case FormTemplateFieldTypes.WEATHER:
      return 'Default to current weather';
    case FormTemplateFieldTypes.USER:
      return 'Pre-fill with logged-in user';
    default:
      throw new Error(
        `Unrecognized type for dynamic default field: ${fieldType}`,
      );
  }
}

export function EditIsDynamicDefaultField({
  prefix,
}: EditDynamicDefaultFieldProps) {
  const fieldName = getFieldNameWithPrefix(
    'dynamicallyGenerateDefault',
    prefix,
  );

  const {
    input: { value: fieldType },
  } = useField<FormTemplateFieldTypes>(getFieldNameWithPrefix('type', prefix));

  const supportsDynamicDefault =
    supportedDynamicDefaultFieldTypes.has(fieldType);
  useField<boolean>(fieldName, { initialValue: supportsDynamicDefault });

  if (!supportsDynamicDefault) {
    return null;
  }
  const label = getDynamicDefaultFieldLabel(fieldType);

  return (
    <ModalFieldWrapper>
      <CheckboxField name={fieldName} label={label} />
    </ModalFieldWrapper>
  );
}
